export class Permission {
  public static songsheetsRead = new Permission(
    "songsheets:read",
    "auth.permissions.songsheetsRead",
  );

  public readonly name: string;
  public readonly description: string;

  constructor(name: string, description: string) {
    this.name = name;
    this.description = description;
  }
}

export const permissionsToRequest = [Permission.songsheetsRead];
